<dl
  class="description-list"
  [class.description-list__bottom]="hasSeparationLine()"
>
  <dt
    class="description-list__key"
    [class.description-list__key--wide]="variant() === 'wide'"
  >
    {{ key() | translate }}
  </dt>
  @switch (badgeVariant) {
    @case (ValueBadgeVariant.Error) {
      <dd class="description-list__value">
        <sui-badge icon="alert" variant="soft" color="error">
          {{ stringValue | translate }}
        </sui-badge>
      </dd>
    }
    @case (ValueBadgeVariant.Success) {
      <dd class="description-list__value">
        <sui-badge icon="checkmark" variant="soft" color="success">
          {{ stringValue | translate }}
        </sui-badge>
      </dd>
    }
    @default {
      <dd
        class="description-list__value"
        [class.description-list__value--wide]="variant() === 'wide'"
      >
        <ng-content>{{ stringValue || '-' }}</ng-content>
      </dd>
    }
  }
</dl>
